import React from 'react';
import { NuvoThemeProvider } from '@nuvolo/nuux-theme';
import AwsApolloProvider from '#/app/providers/AwsApolloProvider';
import RouteProvider from '#/app/providers/RouteProvider';
import CognitoAuthProvider from './app/providers/CognitoAuthProvider';
import useClientTheme from '#/common/hooks/useClientTheme';
import SessionProvider from './app/providers/SessionProvider';
import GlobalStyles from './app/GlobalStyles';

const App: React.FC = () => {
  const { theme } = useClientTheme();
  return (
    <NuvoThemeProvider theme={theme}>
      <CognitoAuthProvider>
        <AwsApolloProvider>
          <SessionProvider>
            <GlobalStyles />
            <RouteProvider />
          </SessionProvider>
        </AwsApolloProvider>
      </CognitoAuthProvider>
    </NuvoThemeProvider>
  );
};

export default React.memo(App);
